import { path } from 'ramda';
import React, { useCallback, useState } from 'react';
import {
  SaveButton,
  useNotify,
  useRedirect,
  useRefresh,
  useTranslate
} from 'react-admin';
import { useFormState } from 'react-final-form';
import useFirebaseToken from '../../bitComponents/utils/hooks/useFirebaseToken';
import { graphqlServiceRequest } from '../../bitComponents/utils/requests';
import { API_URL } from '../../constants/constants';

const buildCreateFilterableInsightQuery = (category, type, value, label) =>
  `mutation {
        createFilterableInsight(input: {filterableInsight: {
            category: "${category}"
            , type: "${type}"
            , value: "${value}"
            , label: "${label}"
        }}){
            filterableInsight {
              nodeId
            }
        }
    }`;

const CreateFilterableInsightButton = ({
  handleSubmitWithRedirect,
  ...props
}) => {
  const [loading, setLoading] = useState();
  const formState = useFormState();
  const refresh = useRefresh();
  const notify = useNotify();
  const redirect = useRedirect();
  const translate = useTranslate();
  const { token } = useFirebaseToken();

  const handleClick = useCallback(async () => {
    if (!formState.valid) {
      return;
    }
    try {
      const { category, type, value, label } = formState.values;

      setLoading(true);

      const result = await graphqlServiceRequest(
        token,
        buildCreateFilterableInsightQuery(category, type, value, label),
        API_URL
      );

      const filterableInsightId = path(
        ['data', 'createFilterableInsight', 'filterableInsight', 'nodeId'],
        result
      );

      if (filterableInsightId) {
        setLoading(false);
        refresh();
        notify(translate('ra.notification.created'));
        redirect(`/FilterableInsight/${filterableInsightId}`);
      } else {
        notify(translate('ra.page.error'), 'warning');
      }
    } catch (e) {
      setLoading(false);
      notify(translate('ra.page.error'), 'warning');
    }
  }, [formState.values]);

  return (
    <SaveButton
      disabled={!formState.valid}
      handleSubmitWithRedirect={handleClick}
      saving={loading}
      {...props}
    />
  );
};

export default CreateFilterableInsightButton;
